// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::before,
::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  height: 100%;
  font-size: 100%;
  line-height: 1.5em;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
}

body {
  color: #0f1e2d;
  font-family: "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1;
  word-wrap: break-word;
  word-break: keep-all;
  overflow-wrap: break-word;
  -webkit-text-size-adjust: none;
}

header,
section,
article,
aside,
footer,
nav {
  display: block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-size: 0.875rem;
}

fieldset {
  display: block;
  margin: 0;
  padding: 0;
  border: 0;
}

img {
  max-width: 100%;
  border: 0;
  vertical-align: bottom;
}

ul,
li,
ol {
  list-style: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

pre {
  white-space: pre-wrap;
}

a,
select,
button,
input,
textarea {
  font-family: inherit;
}

button,
input[type=submit] {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button,
button em,
input[type=submit] {
  font-size: inherit;
}

strong,
b {
  font-weight: 700;
}

i {
  font-style: normal;
}

caption,
legend {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px !important;
  color: transparent;
  font-size: 1px;
  line-height: 0;
  opacity: 0;
}

address,
em {
  font-style: normal;
}

a {
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

mark {
  color: inherit;
  font-weight: 800;
  background: 0 0;
}

button,
input {
  border-radius: 0;
  outline: none;
}

input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}`, "",{"version":3,"sources":["webpack://./src/scss/reset.scss"],"names":[],"mappings":"AAEA;;;EAGE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;AAAF;;AAGA;EACE,cAAA;EACA,gQAAA;EAIA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,8BAAA;AAHF;;AAMA;;;;;;EAME,cAAA;AAHF;;AAMA;;;;;;EAME,SAAA;EACA,UAAA;EACA,mBAAA;AAHF;;AAMA;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAHF;;AAMA;EACE,eAAA;EACA,SAAA;EACA,sBAAA;AAHF;;AAMA;;;EAGE,gBAAA;AAHF;;AAMA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;;;;;EAKE,oBAAA;AAHF;;AAMA;;EAEE,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAHF;;AAMA;;EAEE,SAAA;EACA,UAAA;AAHF;;AAMA;;;EAGE,kBAAA;AAHF;;AAMA;;EAEE,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;AAHF;;AAMA;;EAEE,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,qBAAA;EACA,+CAAA;AAHF;;AAMA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAMA;;EAGE,gBAAA;EACA,aAAA;AAHF;;AAMA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;AAHF","sourcesContent":["@import url(\"https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css\");\n\n*,\n::before,\n::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  font-size: 100%;\n  line-height: 1.5em;\n  -webkit-text-size-adjust: none;\n  -moz-text-size-adjust: none;\n  -ms-text-size-adjust: none;\n}\n\nbody {\n  color: #0f1e2d;\n  font-family: \"Pretendard Variable\", Pretendard, -apple-system,\n    BlinkMacSystemFont, system-ui, Roboto, \"Helvetica Neue\", \"Segoe UI\",\n    \"Apple SD Gothic Neo\", \"Noto Sans KR\", \"Malgun Gothic\", \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1;\n  word-wrap: break-word;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n  -webkit-text-size-adjust: none;\n}\n\nheader,\nsection,\narticle,\naside,\nfooter,\nnav {\n  display: block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n  font-size: 0.875rem;\n}\n\nfieldset {\n  display: block;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\nimg {\n  max-width: 100%;\n  border: 0;\n  vertical-align: bottom;\n}\n\nul,\nli,\nol {\n  list-style: none;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\npre {\n  white-space: pre-wrap;\n}\n\na,\nselect,\nbutton,\ninput,\ntextarea {\n  font-family: inherit;\n}\n\nbutton,\ninput[type=\"submit\"] {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\nbutton,\nbutton em,\ninput[type=\"submit\"] {\n  font-size: inherit;\n}\n\nstrong,\nb {\n  font-weight: 700;\n}\n\ni {\n  font-style: normal;\n}\n\ncaption,\nlegend {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  margin: -1px !important;\n  color: transparent;\n  font-size: 1px;\n  line-height: 0;\n  opacity: 0;\n}\n\naddress,\nem {\n  font-style: normal;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);\n}\n\nmark {\n  color: inherit;\n  font-weight: 800;\n  background: 0 0;\n}\n\nbutton,\ninput {\n  -webkit-border-radius: 0;\n  border-radius: 0;\n  outline: none;\n}\n\ninput {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
